(function () {
  var header = document.getElementById('header-sticky');

  if (!header || !header.classList.contains('sticky_header')) return;

  var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
  var stickyStart = 120;
  var hideOffset = 8;
  var ticking = false;

  function updateHeaderState() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;

    if (scrollTop <= stickyStart) {
      header.classList.remove('fixed', 'is-hidden');
      lastScrollTop = scrollTop;
      ticking = false;
      return;
    }

    header.classList.add('fixed');

    if (scrollTop > lastScrollTop + hideOffset) {
      header.classList.add('is-hidden');
    } else if (scrollTop < lastScrollTop - hideOffset) {
      header.classList.remove('is-hidden');
    }

    lastScrollTop = scrollTop;
    ticking = false;
  }

  function requestHeaderUpdate() {
    if (ticking) return;

    ticking = true;

    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(updateHeaderState);
      return;
    }

    window.setTimeout(updateHeaderState, 16);
  }

  window.addEventListener('scroll', requestHeaderUpdate, { passive: true });
  window.addEventListener('resize', requestHeaderUpdate);
  updateHeaderState();
})();

$(document).ready(function() {
  var $body = $('body');
  var $overlay = $('.overlay');

  function isQuickviewOpen() {
    return $('.quickview-popup.is-open').length > 0 || $body.hasClass('quick-active');
  }

  function isLightboxOpen() {
    return $('.slick-lightbox').filter(function() {
      return !$(this).hasClass('slick-lightbox-hide') && !$(this).hasClass('slick-lightbox-hide-init');
    }).length > 0;
  }

  function syncUiState() {
    var shouldLock =
      $('.product-review.open-model, .size-popup.active, .search-popup.active, .out-of-stock-form.active').length > 0 ||
      $('.subscribe-popup:visible').length > 0 ||
      isQuickviewOpen() ||
      isLightboxOpen() ||
      $body.hasClass('cartOpen') ||
      $body.hasClass('mobile-open');

    var shouldUseBaseOverlay =
      $('.product-review.open-model, .out-of-stock-form.active').length > 0 ||
      isQuickviewOpen() ||
      $body.hasClass('mobile-open');

    $body.toggleClass('no-scroll', shouldLock);
    $overlay.toggleClass('active', shouldUseBaseOverlay);
    $overlay.toggleClass('cart-overlay', $body.hasClass('cartOpen'));
  }

  function buildSlickArrow(direction, label) {
    return (
      '<button class="slick-' +
      direction +
      ' slick-arrow" type="button" aria-label="' +
      label +
      '"><span class="slickbtn"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M4.25 2.25L8 6L4.25 9.75" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg></span></button>'
    );
  }

  function runOnNextFrame(callback) {
    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(callback);
      return;
    }

    setTimeout(callback, 16);
  }

  function syncSlickFocusableState(scope) {
    var root = scope && scope.jquery ? scope[0] : (scope || document);
    if (!root || !root.querySelectorAll) return;

    Array.prototype.slice.call(root.querySelectorAll('.slick-slide')).forEach(function(slide) {
      var isHidden = slide.getAttribute('aria-hidden') === 'true';
      var focusables = Array.prototype.slice.call(
        slide.querySelectorAll('a, button, input, select, textarea, [tabindex], .nice-select')
      );

      focusables.forEach(function(element) {
        if (!element || element.matches('input[type="hidden"]')) return;

        if (isHidden) {
          if (!element.hasAttribute('data-slick-managed')) {
            element.setAttribute('data-slick-managed', 'true');
            element.setAttribute(
              'data-slick-orig-tabindex',
              element.hasAttribute('tabindex') ? element.getAttribute('tabindex') : ''
            );
          }

          element.setAttribute('tabindex', '-1');
          return;
        }

        if (!element.hasAttribute('data-slick-managed')) return;

        var originalTabindex = element.getAttribute('data-slick-orig-tabindex');

        if (originalTabindex === '') {
          element.removeAttribute('tabindex');
        } else {
          element.setAttribute('tabindex', originalTabindex);
        }

        element.removeAttribute('data-slick-managed');
        element.removeAttribute('data-slick-orig-tabindex');
      });
    });
  }

  var scheduleSlickFocusSync = (function() {
    var pending = false;
    var pendingScope = document;

    return function(scope) {
      pendingScope = scope || document;
      if (pending) return;
      pending = true;

      runOnNextFrame(function() {
        pending = false;
        syncSlickFocusableState(pendingScope || document);
      });
    };
  })();

  $(document).on('init reInit afterChange setPosition', '.slick-slider', function() {
    scheduleSlickFocusSync(this);
  });

  function observeWhenVisible(element, callback, rootMargin) {
    if (!element || element.dataset.kgaLazyObserved === 'true' || element.dataset.kgaLazyInit === 'true') {
      return;
    }

    function initNow() {
      if (element.dataset.kgaLazyInit === 'true') return;

      element.dataset.kgaLazyInit = 'true';
      callback($(element));
      scheduleSlickFocusSync(element);
    }

    if (!('IntersectionObserver' in window)) {
      initNow();
      return;
    }

    element.dataset.kgaLazyObserved = 'true';

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(element);
        observer.disconnect();
        initNow();
      });
    }, {
      rootMargin: rootMargin || '180px 0px'
    });

    observer.observe(element);
  }

  function initWithSlick($element, callback) {
    if ($.fn && $.fn.slick) {
      callback($element);
      return;
    }

    if (typeof window.loadKgaSlick !== 'function') return;

    window.loadKgaSlick()
      .then(function() {
        callback($element);
      })
      .catch(function() {});
  }

  function initVisibleCountdowns(scope) {
    var elements = Array.prototype.slice.call((scope || document).querySelectorAll('.flip-countdown, .js-flip-countdown'));

    if (!elements.length) return;

    elements.forEach(function(element) {
      if (!element || element.dataset.countdownObserved === 'true' || element.dataset.countdownInitialized === 'true') {
        return;
      }

      if (!('IntersectionObserver' in window)) {
        countDownIni(element);
        return;
      }

      element.dataset.countdownObserved = 'true';

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(element);
          observer.disconnect();
          countDownIni(element);
        });
      }, {
        rootMargin: '200px 0px'
      });

      observer.observe(element);
    });
  }

  $('.edit-spacer input[type="hidden"][name="_method"][value="put"]').remove();

  jQuery('.product-write-review').on('click', function() {
    $('.product-review').toggleClass('open-model');
    $body.toggleClass('open', $('.product-review').hasClass('open-model'));
    syncUiState();
  });

  jQuery('.overlay,.review-close-icon').on('click', function() {
    $('.product-review').removeClass('open-model');
    $body.removeClass('open');
    syncUiState();
  });

  initVisibleCountdowns(document);

  /* size popup */
  $('.size-btn').on('click', function() {
    $('.size-popup').toggleClass('active');
    syncUiState();
  });

  $('.close-search, .close-btn').on('click', function() {
    $('.size-popup').removeClass('active');
    syncUiState();
  });

  /* cart popup */
  function openCartDrawer(e) {
    if (e) e.preventDefault();
    setTimeout(function() {
      $body.addClass('cartOpen');
      $('.hmuser').removeClass('active');
      $('.hmuser').next().slideUp('fast');
      syncUiState();
    }, 50);
  }

  if ($('body').hasClass('cart')) {
    $('.cart-header, .kga-cart-btn').on('click', function(event) {
      event.preventDefault();
      return false;
    });
  } else {
    $('.cart-header, .kga-cart-btn').on('click', openCartDrawer);
  }

  $('body').on('click', '.overlay.cart-overlay, .closecart', function(e) {
    e.preventDefault();
    $body.removeClass('cartOpen');
    setCouponPopupState(false);
    setGiftPopupState(false);
    syncUiState();
  });

  function setCouponPopupState(isOpen) {
    $('.coupon-popup')
      .toggleClass('active', isOpen)
      .attr('aria-hidden', isOpen ? 'false' : 'true');

    $('.coupan-icon')
      .toggleClass('is-active', isOpen)
      .attr('aria-expanded', isOpen ? 'true' : 'false');
  }

  function setGiftPopupState(isOpen) {
    $('.gift-popup')
      .toggleClass('active', isOpen)
      .attr('aria-hidden', isOpen ? 'false' : 'true');

    $('.gift-icon')
      .toggleClass('is-active', isOpen)
      .attr('aria-expanded', isOpen ? 'true' : 'false');
  }

  function syncCouponButtonState($scope) {
    ($scope && $scope.length ? $scope : $('.coupon-popup')).each(function() {
      var $popup = $(this);
      var $button = $popup.find('.apply-coupon-btn');
      var code = $.trim($popup.find('.discount-coupon').val() || '');
      var disabled = !code.length;

      $button.prop('disabled', disabled).attr('aria-disabled', disabled ? 'true' : 'false');
    });
  }

  function applyCouponCode($scope) {
    var $popup = ($scope && $scope.length ? $scope : $('.coupon-popup')).first();
    var $input = $popup.find('.discount-coupon');
    var $button = $popup.find('.apply-coupon-btn');
    var baseUrl = $button.attr('data-base-url') || '/checkout?discount=';
    var code = $.trim($input.val() || '');

    syncCouponButtonState($popup);

    if (!code.length) {
      $input.trigger('focus');
      return;
    }

    window.location.href = baseUrl + encodeURIComponent(code);
  }

  /* coupon popup */
  $(document).on('click', '.coupan-icon', function() {
    var shouldOpen = !$('.coupon-popup').hasClass('active');
    setGiftPopupState(false);
    setCouponPopupState(shouldOpen);

    if (shouldOpen) {
      setTimeout(function() {
        $('.coupon-popup .discount-coupon').trigger('focus');
      }, 40);
    }
  });

  $(document).on('click', '.close-coupon', function() {
    setCouponPopupState(false);
  });

  /* coupon code */
  $('body').on('input keyup change', '.discount-coupon', function() {
    syncCouponButtonState($(this).closest('.coupon-popup'));
  });

  $('body').on('keydown', '.discount-coupon', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      applyCouponCode($(this).closest('.coupon-popup'));
    }
  });

  $('body').on('click', '.apply-coupon-btn', function(e) {
    e.preventDefault();
    applyCouponCode($(this).closest('.coupon-popup'));
  });

  /* gift popup */
  $(document).on('click', '.gift-icon', function() {
    var shouldOpen = !$('.gift-popup').hasClass('active');
    setCouponPopupState(false);
    setGiftPopupState(shouldOpen);
  });

  $(document).on('click', '.close-gift', function() {
    setGiftPopupState(false);
  });

  syncCouponButtonState($('.coupon-popup'));

  function destroyProductZoom() {
    if (!window.jQuery || !jQuery.fn || !jQuery.fn.zoom) return;

    $('.pdp-itm-img.zoom').each(function() {
      try {
        $(this).trigger('zoom.destroy');
      } catch (error) {
        /* noop */
      }

      $(this).find('.zoomImg').remove();
    });
  }

  function initProductZoom() {
    if (!window.jQuery || !jQuery.fn || !jQuery.fn.zoom) return;

    destroyProductZoom();

    var canUseHoverZoom =
      window.matchMedia &&
      window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (!canUseHoverZoom) return;

    $('.pdp-itm-img.zoom').each(function() {
      var zoomUrl = $(this).find('img').attr('data-zoom-src') || false;

      $(this).zoom({
        url: zoomUrl,
        callback: false,
        target: false,
        duration: 120,
        on: 'mouseover',
        touch: false,
        onZoomIn: false,
        onZoomOut: false,
        magnify: 2
      });
    });
  }

  function clampLightboxZoom(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function setLightboxZoom($img, scale, originX, originY) {
    if (!$img || !$img.length) return 1;

    var nextScale = clampLightboxZoom(scale, 1, 4);

    if (typeof originX === 'number' && typeof originY === 'number') {
      $img.css('transform-origin', originX + '% ' + originY + '%');
    }

    $img
      .data('lbScale', nextScale)
      .toggleClass('is-wheel-zoomed', nextScale > 1.01)
      .css('transform', nextScale > 1.01 ? 'scale(' + nextScale.toFixed(3) + ')' : '');

    return nextScale;
  }

  function resetLightboxZoom($scope) {
    var $root = $scope && $scope.length ? $scope : $('.slick-lightbox');

    $root.find('.slick-lightbox-slick-img').each(function() {
      $(this)
        .removeClass('is-wheel-zoomed')
        .removeData('lbScale')
        .css({
          transform: '',
          transformOrigin: ''
        });
    });
  }

  var lightboxScrollTop = 0;

  function lockLightboxScroll() {
    if ($body.hasClass('lightbox-scroll-lock')) return;

    lightboxScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.documentElement.classList.add('lightbox-scroll-lock');
    $body
      .addClass('lightbox-open lightbox-scroll-lock')
      .css('top', -lightboxScrollTop + 'px');
  }

  function unlockLightboxScroll() {
    var scrollTop = lightboxScrollTop;

    document.documentElement.classList.remove('lightbox-scroll-lock');
    $body
      .removeClass('lightbox-open lightbox-scroll-lock')
      .css('top', '');

    window.scrollTo(0, scrollTop);
  }

  /* mobile filter popup */
  $('body').on('click', '.mobile-facets__open', function() {
    $body.addClass('mobile-open');
    syncUiState();
  });

  $('.overlay').on('click', function() {
    $body.removeClass('mobile-open overflow-hidden-mobile');
    syncUiState();
  });

  $('body').on('click', '.close-filter, .apply-btn', function() {
    $body.removeClass('mobile-open overflow-hidden-mobile');
    syncUiState();
  });

  /* header search popup */
  $('.search-header a').on('click', function(e) {
    e.preventDefault();
    $('.search-popup').toggleClass('active');
    $('.hmuser').removeClass('active');
    $('.hmuser').next().slideUp('fast');
    syncUiState();
  });

  $('.close-search').on('click', function() {
    $('.search-popup').removeClass('active');
    syncUiState();
  });

  /* cookie */
  $('.cookie-close').on('click', function() {
    $('.cookie').slideUp();
  });

  /* subscribe popup */
  if ($('.subscribe-popup').length > 0) {
    syncUiState();
  }

  $('.close-sub-btn').on('click', function() {
    $('.subscribe-popup').slideUp();
    $('.subscribe-overlay').removeClass('open');
    syncUiState();
  });

  /* multi-level accordion nav */
  $('.acnav-label').on('click', function() {
    var label = $(this);
    var parent = label.parent('.has-children');
    var list = label.siblings('.acnav-list');

    if (parent.hasClass('is-open')) {
      list.slideUp('fast');
      parent.removeClass('is-open');
    } else {
      list.slideDown('fast');
      parent.addClass('is-open');
    }
  });

  /* video play */
  $('.play-vid').on('click', function() {
    var video = $('#img-vid')[0];
    var $toggle = $(this);
    if (!video) return;

    if ($toggle.attr('data-click') == 1) {
      $toggle.attr('data-click', 0);
      video.pause();
      $toggle.css('opacity', '1');
    } else {
      $toggle.attr('data-click', 1);
      video.play();
      $toggle.css('opacity', '0');
    }
  });

  function initBestsellSlider($slider) {
    if (!$slider.length || !$.fn || !$.fn.slick) return;

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('setPosition');
      return;
    }

    $slider.slick({
      autoplay: false,
      arrows: true,
      dots: false,
      infinite: false,
      speed: 800,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: buildSlickArrow('prev', 'Previous products'),
      nextArrow: buildSlickArrow('next', 'Next products'),
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  function initTestimonialSlider($slider) {
    if (!$slider.length || !$.fn || !$.fn.slick) return;

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('setPosition');
      return;
    }

    $slider.slick({
      autoplay: false,
      arrows: false,
      dots: true,
      infinite: false,
      speed: 800,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  function initHomeBlogSlider($slider) {
    if (!$slider.length || !$.fn || !$.fn.slick) return;

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('setPosition');
      return;
    }

    $slider.slick({
      autoplay: false,
      arrows: false,
      dots: true,
      infinite: false,
      speed: 800,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  function syncDeferredSlicks(scope) {
    var root = scope || document;

    $(root).find('.bestsell-slider').each(function() {
      observeWhenVisible(this, function($slider) {
        initWithSlick($slider, initBestsellSlider);
      }, '220px 0px');
    });

    $(root).find('.testimonial-slider').each(function() {
      observeWhenVisible(this, function($slider) {
        initWithSlick($slider, initTestimonialSlider);
      }, '220px 0px');
    });

    $(root).find('.home-blog-slider').each(function() {
      observeWhenVisible(this, function($slider) {
        initWithSlick($slider, initHomeBlogSlider);
      }, '220px 0px');
    });
  }

  syncDeferredSlicks(document);

  var slickFocusResizeTimer;
  $(window).on('load resize orientationchange', function() {
    clearTimeout(slickFocusResizeTimer);
    slickFocusResizeTimer = setTimeout(function() {
      scheduleSlickFocusSync(document);
    }, 120);
  });

  document.addEventListener('shopify:section:load', function(event) {
    syncDeferredSlicks(event.target);
    initVisibleCountdowns(event.target);
  });

  function closeLightboxState() {
    unlockLightboxScroll();
    resetLightboxZoom($('.slick-lightbox'));
    initProductZoom();
    syncUiState();
  }

  /* slick lightbox */
  if ($('.lightbox').length > 0) {
    $('.lightbox').slickLightbox({
      itemSelector: 'a.open-lightbox',
      caption: false,
      closeOnBackdropClick: true,
      slick: {
        prevArrow: '<button class="slide-arrow slick-prev" type="button" aria-label="Previous image"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
        nextArrow: '<button class="slide-arrow slick-next" type="button" aria-label="Next image"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>'
      },
      navigateByKeyboard: true,
      layouts: {
        closeButton: '<button class="close" type="button" aria-label="Close image gallery"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none"><path d="M27.7618 25.0008L49.4275 3.33503C50.1903 2.57224 50.1903 1.33552 49.4275 0.572826C48.6647 -0.189868 47.428 -0.189965 46.6653 0.572826L24.9995 22.2386L3.33381 0.572826C2.57102 -0.189965 1.3343 -0.189965 0.571605 0.572826C-0.191089 1.33562 -0.191186 2.57233 0.571605 3.33503L22.2373 25.0007L0.571605 46.6665C-0.191186 47.4293 -0.191186 48.666 0.571605 49.4287C0.952952 49.81 1.45285 50.0007 1.95275 50.0007C2.45266 50.0007 2.95246 49.81 3.3339 49.4287L24.9995 27.763L46.6652 49.4287C47.0465 49.81 47.5464 50.0007 48.0463 50.0007C48.5462 50.0007 49.046 49.81 49.4275 49.4287C50.1903 48.6659 50.1903 47.4292 49.4275 46.6665L27.7618 25.0008Z"></path></svg></button>'
      }
    });

    $('.lightbox')
      .on('show.slickLightbox', function() {
        destroyProductZoom();
        lockLightboxScroll();
        syncUiState();
      })
      .on('hidden.slickLightbox', function() {
        closeLightboxState();
      });

    $('.lightbox').on('shown.slickLightbox', function() {
      var $lightbox = $('.slick-lightbox');

      resetLightboxZoom($lightbox);
      $lightbox.find('.slick-lightbox-slick').off('beforeChange.kgaZoom').on('beforeChange.kgaZoom', function() {
        resetLightboxZoom($lightbox);
      });
    });

    $('body').on('wheel', '.slick-lightbox .slick-lightbox-slick-img', function(event) {
      var originalEvent = event.originalEvent;
      var rect = this.getBoundingClientRect();
      var $img = $(this);
      var currentScale = parseFloat($img.data('lbScale')) || 1;
      var delta = originalEvent && originalEvent.deltaY < 0 ? 0.22 : -0.22;
      var originX;
      var originY;

      if (!originalEvent || !rect.width || !rect.height) return;

      event.preventDefault();
      event.stopPropagation();

      originX = clampLightboxZoom(((originalEvent.clientX - rect.left) / rect.width) * 100, 0, 100);
      originY = clampLightboxZoom(((originalEvent.clientY - rect.top) / rect.height) * 100, 0, 100);

      setLightboxZoom($img, currentScale + delta, originX, originY);
    });

    $('body').on('dblclick', '.slick-lightbox .slick-lightbox-slick-img', function(event) {
      var rect = this.getBoundingClientRect();
      var $img = $(this);
      var currentScale = parseFloat($img.data('lbScale')) || 1;
      var originX;
      var originY;

      event.preventDefault();
      event.stopPropagation();

      if (!rect.width || !rect.height) {
        setLightboxZoom($img, currentScale > 1.05 ? 1 : 2.2, 50, 50);
        return;
      }

      originX = clampLightboxZoom(((event.clientX - rect.left) / rect.width) * 100, 0, 100);
      originY = clampLightboxZoom(((event.clientY - rect.top) / rect.height) * 100, 0, 100);

      setLightboxZoom($img, currentScale > 1.05 ? 1 : 2.2, originX, originY);
    });

  }

  initProductZoom();

  var productZoomResizeTimer;
  $(window).on('resize orientationchange', function() {
    clearTimeout(productZoomResizeTimer);
    productZoomResizeTimer = setTimeout(function() {
      if (!isLightboxOpen()) initProductZoom();
    }, 120);
  });

  /* currency nice-select */
  $('body').on('click', '.currency .nice-select', function(e) {
    e.stopPropagation();
    $(this).toggleClass('open');
  });

  $('body').on('click', function() {
    $('.currency .nice-select').removeClass('open');
  });

  function currencyFormSubmit(event) {
    if (event && event.target && event.target.form) {
      event.target.form.submit();
    }
  }

  $('body').on('click', '.currency .nice-select .list li', function() {
    var currencyWrap = this.closest('.currency');
    if (!currencyWrap) return;

    var selectElement = currencyWrap.querySelector('select');
    if (selectElement) {
      selectElement.value = this.dataset.value || this.getAttribute('data-value') || this.dataset.currency || '';
      var event = new Event('change', { bubbles: true });
      selectElement.dispatchEvent(event);
      currencyFormSubmit({ target: selectElement });
    }
  });

  /* notify me */
  $('body').on('click', '.notify-btn', function(e) {
    e.preventDefault();
    $body.addClass('notify-active');
    $('.out-of-stock-form').addClass('active');
    syncUiState();
  });

  $('body').on('click', '.overlay,.notify-popup-close', function(e) {
    e.preventDefault();
    $body.removeClass('notify-active');
    $('.out-of-stock-form').removeClass('active');
    syncUiState();
  });

  var quickviewRequestId = 0;
  var quickviewTrigger = null;
  var quickviewCache = {};
  var quickviewFetches = {};
  var quickviewCloseTimer = null;
  var quickviewTransitionMs = 220;

  function getQuickviewPopup() {
    return $('.quickview-popup');
  }

  function getQuickviewData() {
    return $('.quickview_popup_data');
  }

  function clearQuickviewCloseTimer() {
    if (quickviewCloseTimer) {
      window.clearTimeout(quickviewCloseTimer);
      quickviewCloseTimer = null;
    }
  }

  function fetchQuickviewMarkup(href) {
    if (Object.prototype.hasOwnProperty.call(quickviewCache, href)) {
      return $.Deferred().resolve(quickviewCache[href]).promise();
    }

    if (quickviewFetches[href]) {
      return quickviewFetches[href];
    }

    quickviewFetches[href] = $.get(href)
      .done(function(product) {
        quickviewCache[href] = product;
      })
      .always(function() {
        delete quickviewFetches[href];
      });

    return quickviewFetches[href];
  }

  function prepareQuickviewPopup() {
    var $popup = getQuickviewPopup();
    var $data = getQuickviewData();

    clearQuickviewCloseTimer();
    $popup.attr('aria-hidden', 'false').removeClass('is-closing');
    $data
      .attr('aria-busy', 'true')
      .html('<div class="quickview-loading">Loading product...</div>')
      .scrollTop(0);

    $body.addClass('quick-active');
    syncUiState();
    runOnNextFrame(function() {
      if ($popup.attr('aria-hidden') === 'true' || !$body.hasClass('quick-active')) {
        return;
      }

      $popup.addClass('is-open');
      syncUiState();
    });

    return $popup;
  }

  function closeQuickview(options) {
    options = options || {};
    quickviewRequestId += 1;
    clearQuickviewCloseTimer();

    var $popup = getQuickviewPopup();
    var $data = getQuickviewData();

    $popup.removeClass('is-open is-loading').attr('aria-hidden', 'true');
    $data.attr('aria-busy', 'false');
    syncUiState();

    quickviewCloseTimer = window.setTimeout(function() {
      if ($popup.hasClass('is-open')) {
        quickviewCloseTimer = null;
        return;
      }
      $data.empty();
      $body.removeClass('quick-active');
      syncUiState();
      quickviewCloseTimer = null;
    }, quickviewTransitionMs);

    if (!options.skipFocusRestore && quickviewTrigger && document.contains(quickviewTrigger)) {
      quickviewTrigger.focus();
    }

    if (!options.keepTrigger) {
      quickviewTrigger = null;
    }
  }

  /* quickview */
  $('body').on('mouseenter focusin touchstart', '.quickview-btn a[data-handle]', function() {
    var handle = $(this).data('handle');
    if (!handle) return;

    if (typeof window.loadKgaSlick === 'function') {
      window.loadKgaSlick().catch(function() {});
    }
    fetchQuickviewMarkup('/products/' + handle + '?view=qv');
  });

  $('body').on('click', '.quickview-close', function(e) {
    e.preventDefault();
    closeQuickview();
  });

  $('body').on('click', '.quickview-btn', function(e) {
    e.preventDefault();

    var handle = $(this).data('handle') || $(this).find('a').data('handle');
    if (!handle) return;

    if (typeof window.loadKgaSlick === 'function') {
      window.loadKgaSlick().catch(function() {});
    }

    quickviewTrigger = $(this).find('a')[0] || this;

    var $popup = prepareQuickviewPopup();
    var $data = getQuickviewData();
    var href = '/products/' + handle + '?view=qv';
    var requestId = quickviewRequestId + 1;

    $popup.addClass('is-loading');
    quickviewRequestId = requestId;

    fetchQuickviewMarkup(href)
      .done(function(product) {
        if (requestId !== quickviewRequestId) return;
        $data.html(product).scrollTop(0);
        runOnNextFrame(function() {
          $data.attr('aria-busy', 'false').focus();
          $popup.removeClass('is-loading');
          syncUiState();
          scheduleSlickFocusSync($popup[0]);
        });
      })
      .fail(function() {
        if (requestId !== quickviewRequestId) return;
        closeQuickview();
      });
  });

  document.addEventListener('kga:slick:ready', function() {
    if (window.__kgaMultiSliderManager) {
      window.__kgaMultiSliderManager.init(document);
    }
    if (typeof window.refreshKgaBestSellers === 'function') {
      window.refreshKgaBestSellers(document);
    }

    syncDeferredSlicks(document);
    scheduleSlickFocusSync(document);
  });

  $('body').on('click', '.overlay', function() {
    if (isQuickviewOpen()) {
      closeQuickview();
    }
  });

  $(document).on('keyup', function(event) {
    if (event.key !== 'Escape' && event.keyCode !== 27) return;

    if (isQuickviewOpen()) {
      closeQuickview();
    }

  });

  /* custom reviews on product page */
  $(window).on('load', function() {
    if ($('.product-detail-left').length > 0) {
      $('.product-detail-left').find('.jdgm-prev-badge').append("<a class='product-write-review d-flex'><svg xmlns='http://www.w3.org/2000/svg' fill='currentColor' id='Outline' viewBox='0 0 24 24' width='16' height='16'><path d='M22.853,1.148a3.626,3.626,0,0,0-5.124,0L1.465,17.412A4.968,4.968,0,0,0,0,20.947V23a1,1,0,0,0,1,1H3.053a4.966,4.966,0,0,0,3.535-1.464L22.853,6.271A3.626,3.626,0,0,0,22.853,1.148ZM5.174,21.122A3.022,3.022,0,0,1,3.053,22H2V20.947a2.98,2.98,0,0,1,.879-2.121L15.222,6.483l2.3,2.3ZM21.438,4.857,18.932,7.364l-2.3-2.295,2.507-2.507a1.623,1.623,0,1,1,2.295,2.3Z'></path></svg> Write a Review</a>");
    }
  });

  syncUiState();
  scheduleSlickFocusSync(document);
});

function responsiveMenu() {
  var isMobile = jQuery(window).width() < 768;
  var $filterColumn = $('.product-filter-column');

  if (isMobile) {
    $filterColumn.prependTo('.product-heading-row .container .row');
  } else {
    $filterColumn.prependTo('.product-list-row');
    if ($('body').hasClass('mobile-open')) {
      $('body').removeClass('mobile-open overflow-hidden-mobile');
      $('.overlay').removeClass('active');
    }
  }
}

jQuery(document).ready(function() {
  responsiveMenu();
});

jQuery(window).on('resize', function() {
  clearTimeout(window.__responsiveMenuTimer);
  window.__responsiveMenuTimer = setTimeout(responsiveMenu, 120);
});

if ($('.my-acc-column').length > 0) {
  jQuery(function ($) {
    var topMenuHeight = $('#daccount-nav').outerHeight();
    $('#account-nav').menuScroll(topMenuHeight);
    $('.account-list li:first-child').addClass('active');
  });

  jQuery.fn.extend({
    menuScroll: function (offset) {
      var topMenu = this;
      var topOffset = offset ? offset : 0;
      var menuItems = $(topMenu).find('a');
      var lastId;

      var scrollItems = $(menuItems).map(function () {
        var item = $($(this).attr('href'));
        if (item.length) {
          return item;
        }
      });

      $(topMenu).on('click', 'a', function (e) {
        var href = $(this).attr('href');
        var offsetTop = href === '#' ? 0 : $(href).offset().top - topOffset;

        function checkWidth() {
          var windowSize = $(window).width();
          if (windowSize <= 767) {
            $('html, body').stop().animate({
              scrollTop: offsetTop - 200
            }, 300);
          } else {
            $('html, body').stop().animate({
              scrollTop: offsetTop - 100
            }, 300);
          }
        }

        checkWidth();
        e.preventDefault();
      });

      $(window).scroll(function () {
        function checkWidth() {
          var windowSize = $(window).width();
          var nm = $('html').scrollTop();
          var nw = $('body').scrollTop();
          var fromTop = (nm > nw ? nm : nw) + topOffset;

          var current = $(scrollItems).map(function () {
            if (windowSize <= 767) {
              if ($(this).offset().top - 250 <= fromTop) return this;
            } else {
              if ($(this).offset().top <= fromTop) return this;
            }
          });

          current = current[current.length - 1];
          var id = current && current.length ? current[0].id : '';

          if (lastId !== id) {
            lastId = id;
            $(menuItems)
              .parent().removeClass('active')
              .end().filter("[href='#" + id + "']").parent().addClass('active');
          }
        }

        checkWidth();
      });
    }
  });
}

function countDownIni(countdown) {
  if (!window.jQuery || !jQuery.fn || typeof jQuery.fn.countdown !== 'function') {
    return;
  }

  $(countdown).each(function () {
    var countdown = $(this);
    var promoperiod;

    if (countdown.data('countdownInitialized')) {
      return;
    }

    if (countdown.attr('data-promoperiod')) {
      promoperiod = new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10);
    } else if (countdown.attr('data-countdown')) {
      promoperiod = countdown.attr('data-countdown');
    }

    if (!promoperiod || isNaN(Date.parse(promoperiod))) {
      return;
    }

    if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
      countdown.data('countdownInitialized', true);
      $(this).addClass('countdown-block');
      countdown.countdown(promoperiod, function (event) {
        countdown.html(
          event.strftime(
            '<span><span>%D</span><span class="dots"> : </span></span>' +
            '<span><span>%H</span><span class="dots"> : </span></span>' +
            '<span><span>%M</span><span class="dots"> : </span></span>' +
            '<span><span class="second">%S</span></span>'
          )
        );
      });
    }

    if (Date.parse(promoperiod) - Date.parse(new Date()) < 0) {
      countdown.data('countdownInitialized', true);
      $(this).parent().css('display', 'none');
    }
  });
}
